import { render } from "./ProfileAccount.vue?vue&type=template&id=1e9ae79a&scoped=true"
import script from "./ProfileAccount.vue?vue&type=script&lang=js"
export * from "./ProfileAccount.vue?vue&type=script&lang=js"

import "./ProfileAccount.vue?vue&type=style&index=0&id=1e9ae79a&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e9ae79a"]])

export default __exports__